import styled from "styled-components";

export const StyledSection = styled.section`
    background-color: white;
    padding: 15px;
    border: 1px solid rgb(238, 237, 239);
    
`;